export const ImmerserSelectors = {
  root: '[data-immerser]',
  layer: '[data-immerser-layer]',
  solid: '[data-immerser-solid]',
  pagerLink: '[data-immerser-pager-link]',
  mask: '[data-immerser-mask]',
  maskInner: '[data-immerser-mask-inner]',
  synchroHover: '[data-immerser-synchro-hover]',
};
